import { ADMIN_MESSAGE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function PutAdminMessage(code, data){
    const api = `${ADMIN_MESSAGE_API}ordinary/${code}/`;
    return axiosHttp.put(api, data);
}